export const CHANGE_PASSWORD_SUCCESS = 'CHANGE_PASSWORD';
export const CHANGE_PASSWORD_PENDING = 'CHANGE_PASSWORD_PENDING';
export const CHANGE_PASSWORD_ERROR = 'CHANGE_PASSWORD_ERROR';
export const RESET_PASSWORD_SUCCESS = 'RESET_PASSWORD';
export const RESET_PASSWORD_PENDING = 'RESET_PASSWORD_PENDING';
export const RESET_PASSWORD_ERROR = 'RESET_PASSWORD_ERROR';
export const REQUEST_EMAIL_VERIFICATION_PENDING = 'REQUEST_EMAIL_VERIFICATION_PENDING';
export const REQUEST_EMAIL_VERIFICATION_SUCCESS = 'REQUEST_EMAIL_VERIFICATION_SUCCESS';
export const REQUEST_EMAIL_VERIFICATION_ERROR = 'REQUEST_EMAIL_VERIFICATION_ERROR';
export const REQUEST_PHONE_NUMBER_VERIFICATION_TOKEN_PENDING = 'REQUEST_PHONE_NUMBER_VERIFICATION_TOKEN_PENDING';
export const REQUEST_PHONE_NUMBER_VERIFICATION_TOKEN_SUCCESS = 'REQUEST_PHONE_NUMBER_VERIFICATION_TOKEN_SUCCESS';
export const REQUEST_PHONE_NUMBER_VERIFICATION_TOKEN_ERROR = 'REQUEST_PHONE_NUMBER_VERIFICATION_TOKEN_ERROR';
export const CHECK_PHONE_NUMBER_VERIFICATION_TOKEN_PENDING = 'CHECK_PHONE_NUMBER_VERIFICATION_TOKEN_PENDING';
export const CHECK_PHONE_NUMBER_VERIFICATION_TOKEN_SUCCESS = 'CHECK_PHONE_NUMBER_VERIFICATION_TOKEN_SUCCESS';
export const CHECK_PHONE_NUMBER_VERIFICATION_TOKEN_ERROR = 'CHECK_PHONE_NUMBER_VERIFICATION_TOKEN_ERROR';

export const CHECK_EMAIL_VERIFICATION_TOKEN_PENDING = 'CHECK_EMAIL_VERIFICATION_TOKEN_PENDING';
export const CHECK_EMAIL_VERIFICATION_TOKEN_SUCCESS = 'CHECK_EMAIL_VERIFICATION_TOKEN_SUCCESS';
export const CHECK_EMAIL_VERIFICATION_TOKEN_ERROR = 'CHECK_EMAIL_VERIFICATION_TOKEN_ERROR';
